import * as React from 'react'
import { Text, Icon, Colors } from '@doordash/design-language'
import {
  SectionContainer,
  ContentText,
  IconListCell,
  CommonTextUrl,
} from './StyleComponents'
import { DasherChatImage } from './images'
import { safetyCourse as t } from './strings'
import { HELP_URL } from '../../../constants'
import { Interpolate } from '@doordash/lib-i18n'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'
import ListCell from '@doordash/component-list-cell'
import { ImageContainer } from './styles'

const sexualHarassmentBullets = [
  t.sections.sexualHarassment.list1(),
  t.sections.sexualHarassment.list2(),
  t.sections.sexualHarassment.list3(),
  t.sections.sexualHarassment.list4(),
  t.sections.sexualHarassment.list5(),
]

export const SexualHarassmentSection = () => (
  <React.Fragment>
    <SectionContainer>
      <Text styles={Text.Styles.Bold32}>
        {t.sections.sexualHarassment.title()}
      </Text>
      <ContentText>{t.sections.sexualHarassment.subtitle1()}</ContentText>
      <ContentText>{t.sections.sexualHarassment.subtitle2()}</ContentText>
      <Text styles={Text.Styles.Bold24}>
        {t.sections.sexualHarassment.header()}
      </Text>
      <ContentText>{t.sections.sexualHarassment.description()}</ContentText>
      <ContentText>{t.sections.sexualHarassment.listHeader()}</ContentText>
      {sexualHarassmentBullets.map(bulletText => (
        <IconListCell
          icon={ListCell.IconTypes.ProhibitedLine}
          string={bulletText}
          color={Colors.SystemRed60}
        />
      ))}
      <Text styles={Text.Styles.Bold24}>{t.sections.retaliation.title()}</Text>
      <ContentText>{t.sections.retaliation.description()}</ContentText>
      <Text styles={Text.Styles.Bold24}>
        {t.sections.retaliationProcess.title()}
      </Text>
      <IconListCell
        icon={ListCell.IconTypes.Number1Line}
        string={
          <Interpolate
            i18n={i18n}
            i18nKey={i18nKeys.safetyCourse__step1_retaliationProcess}
            components={[<CommonTextUrl url={HELP_URL} />]}
          />
        }
      />
      <IconListCell
        icon={ListCell.IconTypes.Number2Line}
        string={t.sections.retaliationProcess.step2()}
      />
      <IconListCell
        icon={ListCell.IconTypes.Number3Line}
        string={t.sections.retaliationProcess.step3()}
      />
      <IconListCell
        icon={ListCell.IconTypes.Number4Line}
        string={t.sections.retaliationProcess.step4()}
      />

      <ImageContainer>
        <DasherChatImage />
      </ImageContainer>
      <Text styles={Text.Styles.Bold24}>
        {t.sections.retaliationProcessExpectations.title()}
      </Text>
      <IconListCell
        icon={ListCell.IconTypes.LockedFill}
        string={t.sections.retaliationProcessExpectations.list1()}
      />
      <IconListCell
        icon={ListCell.IconTypes.CheckCircleFill}
        string={t.sections.retaliationProcessExpectations.list2()}
      />
      <IconListCell
        icon={Icon.Types.ThumbsUpFill}
        string={t.sections.retaliationProcessExpectations.list3()}
      />
      {/* Investigation Section */}
      <Text styles={Text.Styles.Bold24}>
        {t.sections.investigationConclude.title()}
      </Text>
      <ContentText>
        {t.sections.investigationConclude.description()}
      </ContentText>
    </SectionContainer>
  </React.Fragment>
)
